import React, { useEffect, useMemo, useRef, useState } from "react";
import { ChevronLeft } from "@mui/icons-material";
import {
  TextField,
  Button,
  Typography,
  CircularProgress,
  Snackbar,
  Box,
  styled,
  Alert,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  List,
  ListItem,
  Grid,
  useMediaQuery,
  Radio,
  FormControlLabel,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import CustomRadio from "../Extra/CustomRadio";
import { ReactComponent as AppleIcon } from "../../assets/apple.svg";
import { ReactComponent as ProteinIcon } from "../../assets/protein.svg";
import { ReactComponent as CaolriesIcon } from "../../assets/calories.svg";
import {
  addIngredients,
  addMealOrRecipeToDiary,
  updateIngredients
} from "../../api/diaryApi"; // Update to your actual API import
import dayjs from "dayjs";
// import { options800gms, optionsProteins } from "../../utils/mockWeightData";
import {
  getCurrentUserDiaries,
  getCurrentUserDiaryLevels
} from "../../features/diary/diarySlice";
import { useDispatch, useSelector } from "react-redux";
import useThemeColor from "../../utils/useTheme";
import {
  selectAllOptionsProtein,
  selectAllOptions800g,
  selectAllOptionsOtherFood,
  selectAllOptions800gLevel3,
  selectAllOptionsProteinLevel3
} from "../../features/diary/diarySelectors";
import { selectCurrentUser } from "../../features/auth/authSelectors";
import {
  addNotificationUser,
  fetchCurrentUser
} from "../../features/auth/authSlice";
import FoodSearch from "../Extra/FoodSearch";
import { convertItemQuantityToGrams } from "../../utils/weightConvert";
import { selectCurrentTheme } from "../../features/theme/themeSelectors";
import formatNumber from "../../utils/formatNumber";
import { dailyValues } from "../../utils/calculateDVPercent";
import { selectCustomFoodOptions } from "../../features/level3/level3Selectors";
import { useTheme } from "@emotion/react";

const StyledTextFieldContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  margin: theme.spacing(4, 0)
}));

const StyledInputLabel = styled("label")(({ styles }) => ({
  position: "absolute",
  top: "-18px",
  color: styles.inputLabelColor,
  fontSize: "15px",
  pointerEvents: "none"
}));

const StyledTextField = styled(TextField)(({ styles }) => ({
  input: {
    color: styles.color,
    "-webkit-text-fill-color": `${styles.color} !important`
  },
  "& .MuiOutlinedInput-root": {
    "& input[type=number]": {
      "-moz-appearance": "textfield"
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    },
    "& fieldset": {
      borderColor: styles.lightGreyColor
    },
    "&:hover fieldset": {
      borderColor: styles.color
    },
    "&.Mui-focused fieldset": {
      borderColor: styles.color
    },
    "&.Mui-disabled fieldset": {
      borderColor: `${styles.lightGreyColor} !important`
    },
    "&.Mui-disabled": {
      background: styles.lightGreyColor,
      color: styles.color
    }
  }
}));

const excludedFields = [
  "serving_id",
  "serving_description",
  "serving_url",
  "metric_serving_amount",
  "metric_serving_unit",
  "calories",
  "protein"
];

const AddWeightForm = ({
  selectedLevel,
  diaryId,
  activeDay,
  setIsAddingWeight,
  isAddingWeight,
  levelId,
  editData,
  setIsRefreshNeeded,
  setEditCustomFoodToDiary,
  setEditMealToDiary,
  setEditRecipeToDiary,
  oneOffItem,
  setOneOffItem
}) => {
  const [isDiaryRefreshNeeded, setIsDiaryRefreshNeeded] = useState(false);
  const dispatch = useDispatch();
  const amountRef = useRef(null);
  const quantityRef = useRef(null);
  const options800gms = useSelector(selectAllOptions800g);
  const optionsProteins = useSelector(selectAllOptionsProtein);
  const optionsOtherFood = useSelector(selectAllOptionsOtherFood);
  const options800gLevel3 = useSelector(selectAllOptions800gLevel3);
  const optionsProteinLevel3 = useSelector(selectAllOptionsProteinLevel3);
  const allCustomFoodOptions = useSelector(selectCustomFoodOptions);
  const userData = useSelector(selectCurrentUser);
  const [selectedOptionData, setSelectedOptionData] = useState(null);
  const [isMealOrRecipeTab, setIsMealOrRecipeTab] = useState(false);
  const [selectedCustomFood, setSelectedCustomFood] = useState(null);
  const [currentDiaryAddingTab, setCurrentDiaryAddingTab] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [initialFormData, setInitialFormData] = useState(null);
  const [initialCustomFoodFormData, setInitialCustomFoodFormData] = useState(null);
  const [customFoodFormData, setCustomFoodFormData] = useState({
    name: oneOffItem ? oneOffItem.name : "",
    quantity: oneOffItem ? oneOffItem.quantity : "",
    noOfQty: oneOffItem ? oneOffItem.noOfQty : "",
    unit: oneOffItem ? oneOffItem.unit : "grams",
    type: oneOffItem ? oneOffItem.extraDetails?.type || "800g" : "800g",
    details: {
      serving: oneOffItem
        ? oneOffItem.extraDetails.serving
        : {
            serving_id: String(Math.floor(Math.random() * 90000) + 10000),
            metric_serving_amount: "",
            metric_serving_unit: "g",
            calories: "",
            carbohydrate: "",
            protein: "",
            fat: "",
            saturated_fat: "",
            sodium: "",
            potassium: "",
            fiber: "",
            vitamin_a: "",
            vitamin_c: "",
            vitamin_d: "",
            calcium: "",
            iron: ""
          }
    }
  });
  const options = isAddingWeight?.toLowerCase()?.includes("800")
    ? options800gms
    : optionsProteins;
  const isLevel3 = selectedLevel?.levelName === "level3";
  // useMemo(() => {
  //   const baseOptions = isAddingWeight?.toLowerCase()?.includes("800")
  //     ? options800gms
  //     : optionsProteins;

  //   // if (
  //   //   editData?.name &&
  //   //   !baseOptions.some((opt) => opt.value === editData.name)
  //   // ) {
  //   //   return [...baseOptions, { value: editData.name, label: editData.name }];
  //   // }

  //   return baseOptions;
  // }, [isAddingWeight, isDiaryRefreshNeeded, editData]);
  const handleResetAmount = (noOfQty = "") => {
    setFormData((prev) => ({
      ...prev,
      quantity: "",
      noOfQty: noOfQty ?? ""
    }));
  };
  const handleSetAmount = (name, qty, noOfQty, unit) => {
    setFormData((prev) => ({
      quantity: !qty ? "" : qty,
      noOfQty: !noOfQty ? "" : noOfQty,
      unit,
      [isAddingWeight]: name,
      type: prev.type
    }));
  };
  useEffect(() => {
    if (selectedOptionData || selectedCustomFood) {
      if (amountRef.current) {
        amountRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
        amountRef.current.focus();
      }
    }
  }, [selectedOptionData, selectedCustomFood]);
  useEffect(() => {
    if (isDiaryRefreshNeeded) {
      dispatch(getCurrentUserDiaryLevels(dayjs().format("YYYY-MM-DD")));
      setIsDiaryRefreshNeeded(false);
    }
  }, [isDiaryRefreshNeeded]);

  // Store initial custom food form data when editing oneOffItem
  useEffect(() => {
    if (oneOffItem && !initialCustomFoodFormData) {
      setInitialCustomFoodFormData({
        name: customFoodFormData.name,
        quantity: customFoodFormData.quantity,
        noOfQty: customFoodFormData.noOfQty,
        unit: customFoodFormData.unit,
        type: customFoodFormData.type,
        details: JSON.parse(JSON.stringify(customFoodFormData.details))
      });
    }
  }, [oneOffItem]);

  const [formData, setFormData] = useState({
    quantity: editData?.quantity || "",
    noOfQty: editData?.noOfQty || "",
    type: isAddingWeight?.toLowerCase()?.includes("800")
      ? "800g"
      : isAddingWeight?.toLowerCase()?.includes("protein")
      ? "protein"
      : "other",
    unit: editData?.unit || "grams",
    [isAddingWeight]: editData?.name
      ? options?.map((item) => item.value)?.includes(editData?.name)
        ? editData?.name
        : options
            ?.map((item) => item.value)
            ?.includes(editData?.name?.toLowerCase())
        ? editData?.name?.toLowerCase()
        : "others"
      : "",
    customFoodType: editData?.name
      ? options?.map((item) => item.value)?.includes(editData?.name)
        ? ""
        : editData?.name
      : ""
  });
  const [favoriteFood, setFavoriteFood] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const loading = false; // Replace with actual loading state if needed
  const styles = useThemeColor();
  const theme = useTheme(); // Use theme hook to get the theme
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)");
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [disabledFields, setDisabledFields] = useState({
    quantity: false,
    noOfQty: false,
    unit: false
  });
  useEffect(() => {
    setDisabledFields({
      quantity:
        editData?.noOfQty ||
        editData?.extraDetails?.noOfQty ||
        selectedCustomFood?.noOfQty ||
        selectedOptionData?.noOfQty ||
        selectedOptionData?.extraDetails?.noOfQty
          ? true
          : false,
      noOfQty:
        editData?.quantity ||
        editData?.extraDetails?.quantity ||
        selectedCustomFood?.quantity ||
        selectedOptionData?.quantity ||
        selectedOptionData?.extraDetails?.quantity
          ? true
          : false,
      unit:
        editData?.noOfQty ||
        editData?.extraDetails?.noOfQty ||
        selectedCustomFood?.noOfQty ||
        selectedOptionData?.noOfQty ||
        selectedOptionData?.extraDetails?.noOfQty
          ? true
          : false
    });

    if (editData?.extraDetails) setSelectedOptionData(editData?.extraDetails);

    // Store initial form data when editing
    if (editData?._id && !initialFormData) {
      setInitialFormData({
        quantity: formData.quantity,
        noOfQty: formData.noOfQty,
        unit: formData.unit,
        selectedOption: editData?.extraDetails || null
      });
    }
  }, [editData, selectedOptionData]);

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    // Allow only numeric values and ensure it's at least 0
    if (Number(value) >= 0 && +value <= 9999) {
      handleInputChange(e);
      setDisabledFields({
        quantity:
          editData?.noOfQty ||
          editData?.extraDetails?.noOfQty ||
          selectedCustomFood?.noOfQty ||
          selectedOptionData?.noOfQty ||
          selectedOptionData?.extraDetails?.noOfQty
            ? true
            : false,
        noOfQty:
          editData?.quantity ||
          editData?.extraDetails?.quantity ||
          selectedCustomFood?.quantity ||
          selectedOptionData?.quantity ||
          selectedOptionData?.extraDetails?.quantity
            ? true
            : value === ""
            ? false
            : true,
        unit:
          editData?.noOfQty ||
          editData?.extraDetails?.noOfQty ||
          selectedCustomFood?.noOfQty ||
          selectedOptionData?.noOfQty ||
          selectedOptionData?.extraDetails?.noOfQty
            ? true
            : false
      });
    }
  };

  // Handle noOfQty change
  const handleNoOfQtyChange = (e) => {
    const value = e.target.value;
    // Allow only numeric values and ensure it's at least 0
    if (Number(value) >= 0 && +value <= 9999) {
      handleInputChange(e);
      setDisabledFields({
        quantity:
          editData?.noOfQty ||
          editData?.extraDetails?.noOfQty ||
          selectedCustomFood?.noOfQty ||
          selectedOptionData?.noOfQty ||
          selectedOptionData?.extraDetails?.noOfQty
            ? true
            : value === ""
            ? false
            : true,
        noOfQty:
          editData?.quantity ||
          selectedCustomFood?.quantity ||
          editData?.extraDetails?.quantity ||
          selectedOptionData?.quantity ||
          selectedOptionData?.extraDetails?.quantity
            ? true
            : false,
        unit:
          editData?.noOfQty ||
          selectedCustomFood?.noOfQty ||
          editData?.extraDetails?.noOfQty ||
          selectedOptionData?.noOfQty ||
          selectedOptionData?.extraDetails?.noOfQty
            ? true
            : value === ""
            ? false
            : true
      });
      const levelData = JSON.parse(
        localStorage.getItem("lastDiaryVisitedLevel") || "{}"
      );
      localStorage.setItem(
        "lastDiaryVisitedLevel",
        JSON.stringify({
          ...levelData,
          unit: "grams"
        })
      );
    }
  };
  const currentTheme = useSelector(selectCurrentTheme);
  let customScalingFactor = 0;
  if (
    (editData ? editData?.extraDetails : selectedOptionData)?.isCustomFood ||
    (editData ? editData?.extraDetails : selectedOptionData)?.isRecipe ||
    editData?.type === "customFood"
  ) {
    if ((editData ? editData?.extraDetails : selectedOptionData)?.isRecipe) {
      // For recipes, calculate scaling based on recipe type
      const recipe = editData ? editData?.extraDetails : selectedOptionData;
      if (recipe.recipeType === "service") {
        customScalingFactor =
          formData?.noOfQty / recipe.servicing_per_recipe || 1;
      } else {
        // weight-based recipe
        customScalingFactor = formData?.quantity
          ? formData?.quantity / (recipe.servicing_per_recipe || 1)
          : 1;
      }
    } else {
      // Original custom food logic
      customScalingFactor = formData?.noOfQty
        ? formData?.noOfQty
        : +convertItemQuantityToGrams(formData).quantity /
          +(selectedOptionData || editData
            ? convertItemQuantityToGrams(selectedOptionData || editData)
                ?.quantity || 1
            : 1);
    }
  }

  const scalingFactor =
    ((editData ? editData?.extraDetails : selectedOptionData)?.isCustomFood ||
      (editData ? editData?.extraDetails : selectedOptionData)?.isRecipe ||
      editData?.type === "customFood") &&
    customScalingFactor
      ? customScalingFactor
      : +convertItemQuantityToGrams(
          formData,
          (editData ? editData?.extraDetails : selectedOptionData)?.serving
            ?.metric_serving_amount
        ).quantity /
          (editData ? editData?.extraDetails : selectedOptionData)?.serving
            ?.metric_serving_amount || formData?.noOfQty;
  // Exclude non-nutrient fields and specific fields like `protein` and `calories`
  const nutrientFields =
    (editData ? editData?.extraDetails : selectedOptionData) &&
    (editData?.extraDetails || selectedOptionData?.serving)
      ? Object.entries(
          (editData ? editData?.extraDetails : selectedOptionData)?.serving
        ).filter(([key, value]) => {
          return !excludedFields.includes(key) && !isNaN(Number(value));
        })
      : [];

  const formattedNutrients = nutrientFields?.map(([key, value]) => {
    const numericValue = parseFloat(value)
      ? (parseFloat(value) * scalingFactor).toFixed(2)
      : 0; // Safely parse the value
    return {
      name: key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: parseFloat(numericValue), // Ensure the value remains a valid number
      unit: "g",
      percent: dailyValues[key]
        ? Math.round(
            ((parseFloat(value) * scalingFactor || 0) / dailyValues[key]) * 100
          )
        : 0 // Handle cases where dailyValues[key] might be missing
    };
  });
  useEffect(() => {
    const levelData = JSON.parse(
      localStorage.getItem("lastDiaryVisitedLevel") || "{}"
    );
    if (levelData?.unit) {
      setFormData({ ...formData, unit: levelData?.unit });
    }
  }, []);
  const formatNumber = (value) => {
    if (!value || isNaN(value) || !+value) return "0";
    return value >= 1
      ? Math.round(value)?.toLocaleString()
      : parseFloat(value)?.toFixed(2);
  };

  const getNutrientValue = (name, unit = "", notNeededPercent = false) => {
    const nutrient = formattedNutrients?.find((n) => n.name === name);
    if (!nutrient) return `0${unit || ""}${!notNeededPercent ? " (0%)" : ""}`; // Fallback if nutrient is not found
    const value = nutrient?.value || 0; // Default to 0 if value is undefined or null
    const percent = nutrient?.percent || 0; // Default to 0 if percent is undefined or NaN
    const unitString = unit || nutrient?.unit || ""; // Default to empty string if no unit is provided

    return `${formatNumber(value)}${unitString}${
      !notNeededPercent && unitString ? ` (${formatNumber(percent)}%)` : ""
    }`;
  };
  const handleCustomFoodInputChange = (e) => {
    const { name, value } = e.target;

    // Check if the name includes nested keys (e.g., "details.serving.calories")
    const keys = name.split(".");

    setCustomFoodFormData((prevState) => {
      let updatedFormData = { ...prevState };

      // Navigate to the correct nested key
      let currentLevel = updatedFormData;
      for (let i = 0; i < keys.length - 1; i++) {
        currentLevel[keys[i]] = { ...currentLevel[keys[i]] }; // Ensure immutability
        currentLevel = currentLevel[keys[i]];
      }

      // Update the value at the final key
      currentLevel[keys[keys.length - 1]] = value;

      return updatedFormData;
    });
  };
  const NutrientRow = ({ name, unit, notNeededPercent = false }) => (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      py={0.5}
    >
      <Typography fontSize="13px">{name}</Typography>
      <Typography fontSize="13px">
        {getNutrientValue(name, unit, notNeededPercent)}
      </Typography>
      {/* <Typography fontSize="13px">{calculatePercentDV(name, unit)}</Typography> */}
    </Box>
  );
  useEffect(() => {
    if (isLevel3 && (selectedOptionData?.food_id || selectedCustomFood?.name)) {
      setFormData((prev) => ({
        ...prev,
        [isAddingWeight]:
          selectedOptionData?.food_name || selectedCustomFood?.name
      }));
    }
  }, [selectedOptionData, selectedCustomFood]);
  const favoriteOptionsData = useMemo(() => {
    if (selectedLevel?.levelName === "level3") {
      return formData?.type?.toLowerCase()?.includes("800")
        ? options800gLevel3
        : formData?.type?.toLowerCase()?.includes("protein")
        ? optionsProteinLevel3
        : optionsOtherFood;
    }
  }, [isAddingWeight, formData?.type]);

  // Check if form has changed from initial values
  const hasFormChanged = () => {
    if (!editData?._id || !initialFormData) return true;

    return (
      formData.quantity !== initialFormData.quantity ||
      formData.noOfQty !== initialFormData.noOfQty ||
      formData.unit !== initialFormData.unit
    );
  };

  // Check if custom food form has changed from initial values
  const hasCustomFoodFormChanged = () => {
    if (!oneOffItem || !initialCustomFoodFormData) return true;

    const servingChanged = JSON.stringify(customFoodFormData.details.serving) !==
      JSON.stringify(initialCustomFoodFormData.details.serving);

    return (
      customFoodFormData.name !== initialCustomFoodFormData.name ||
      customFoodFormData.quantity !== initialCustomFoodFormData.quantity ||
      customFoodFormData.noOfQty !== initialCustomFoodFormData.noOfQty ||
      customFoodFormData.unit !== initialCustomFoodFormData.unit ||
      customFoodFormData.type !== initialCustomFoodFormData.type ||
      servingChanged
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      if (oneOffItem) {
        let correctedCalories = 0;
        if (
          !customFoodFormData.details.serving?.calories &&
          Number(customFoodFormData.details.serving?.protein) &&
          Number(customFoodFormData.details.serving?.carbohydrate) &&
          Number(customFoodFormData.details.serving?.fat)
        ) {
          correctedCalories = Math.round(
            (Number(customFoodFormData.details.serving?.protein) || 0) * 4 +
              (Number(customFoodFormData.details.serving?.carbohydrate) || 0) *
                4 +
              (Number(customFoodFormData.details.serving?.fat) || 0) * 9
          );
        }
        if (correctedCalories > 0) {
          customFoodFormData.details.serving.calories = correctedCalories;
        }

        const currentTime = dayjs().format("hh:mm A");
        const tomorrow = dayjs().add(1, "day").startOf("day");
        const isTomorrow = dayjs(activeDay).isSame(tomorrow, "day");

        await updateIngredients({
          diaryId,
          levelId,
          ingredientId: oneOffItem._id,
          currentDayDate: activeDay,
          completionNotNeeded: isTomorrow,
          [customFoodFormData?.type === "800g"
            ? "entry800g"
            : customFoodFormData?.type === "other"
            ? "otherFood"
            : customFoodFormData?.type]: {
            name: customFoodFormData?.name || "One-off",
            // noOfQty: customFoodFormData?.noOfQty,
            // quantity: customFoodFormData?.quantity,
            time: currentTime,
            // unit: customFoodFormData?.unit,
            extraDetails: {
              ...customFoodFormData,
              isCustomFood: true,
              isFromOneOff: true,
              serving: {
                ...Object.fromEntries(
                  Object.entries(
                    customFoodFormData?.details?.serving || {}
                  ).map(([key, value]) => [key, value === "" ? 0 : value])
                )
              }
            }
          }
        });

        setSnackbarMessage("One-off entry updated successfully.");
        setOpenSnackbar(true);
        setIsAddingWeight("");
        setIsRefreshNeeded(true);
        dispatch(getCurrentUserDiaries({ levelId, activeDay }));
        dispatch(getCurrentUserDiaryLevels(dayjs().format("YYYY-MM-DD")));
        // dispatch(addNotificationUser(dayjs().format("YYYY-MM-DD")));
        setOneOffItem(null);
        localStorage.setItem(
          "lastDiaryVisitedLevel",
          JSON.stringify({
            level: selectedLevel?.levelName,
            activeDay,
            unit: customFoodFormData?.unit,
            lastUpdated: dayjs().format("YYYY-MM-DD")
          })
        );
        return;
      }

      const isRecipe =
        selectedCustomFood?.isRecipe || selectedOptionData?.isRecipe;

      if (isRecipe) {
        // Handle recipe submission using addMealOrRecipeToDiary
        if (!formData.quantity && !formData.noOfQty) {
          setSnackbarMessage("Please enter a quantity.");
          setOpenSnackbar(true);
          return;
        }

        const currentTime = dayjs().format("hh:mm A");
        const tomorrow = dayjs().add(1, "day").startOf("day");
        const isTomorrow = dayjs(activeDay).isSame(tomorrow, "day");

        // Calculate the consumed amount based on recipe type
        const consumedAmount =
          selectedCustomFood?.recipeType === "service"
            ? formData.noOfQty
            : formData.quantity;

        if (editData?._id) {
          // Update existing recipe entry
          await updateIngredients({
            diaryId,
            levelId,
            ingredientId: editData?._id,
            currentDayDate: activeDay,
            completionNotNeeded: isTomorrow,
            recipe: {
              name: selectedCustomFood?.name || selectedCustomFood?.recipeName,
              recipeId: selectedCustomFood?._id,
              consumedAmount: consumedAmount,
              recipeType: selectedCustomFood?.recipeType,
              time: currentTime,
              unit:
                selectedCustomFood?.recipeType === "service"
                  ? "servings"
                  : formData?.unit,
              extraDetails: {
                ...selectedCustomFood,
                consumedAmount: consumedAmount,
                consumedUnit:
                  selectedCustomFood?.recipeType === "service"
                    ? "servings"
                    : formData?.unit
              }
            }
          });
        } else {
          // Add new recipe entry
          await addMealOrRecipeToDiary({
            levelId,
            type: "recipe",
            mealOrRecipeId: selectedCustomFood?._id,
            currentDayDate: activeDay,
            time: currentTime,
            totalConsumed: consumedAmount,
            completionNotNeeded: isTomorrow
          });
        }

        setSnackbarMessage("Recipe logged successfully.");
        setOpenSnackbar(true);
        setFormData({ quantity: "", noOfQty: "", type: formData.type });
        setIsAddingWeight("");
        setIsRefreshNeeded(true);
        setSelectedCustomFood(null);
        setSelectedOptionData(null);
        dispatch(getCurrentUserDiaries({ levelId, activeDay }));
        dispatch(getCurrentUserDiaryLevels(dayjs().format("YYYY-MM-DD")));
        dispatch(addNotificationUser(dayjs().format("YYYY-MM-DD")));

        return; // Exit early for recipe handling
      }
      if (
        !formData?.[isAddingWeight] || isLevel3
          ? !formData.quantity && !formData.noOfQty
          : !formData.quantity
      ) {
        const errors = [];
        if (!formData?.[isAddingWeight])
          errors.push("Please select a food type.");
        if (
          isLevel3
            ? !formData.quantity && !formData.noOfQty
            : !formData.quantity
        )
          errors.push("Please enter a quantity.");
        setSnackbarMessage(errors.join(" "));
        setOpenSnackbar(true);
        return;
      }
      if (formData?.customFoodType?.toLowerCase() === "others") {
        setSnackbarMessage(
          "Please specify name of item, Others is not accepted!"
        );
        setOpenSnackbar(true);
        return;
      }
      const currentTime = dayjs().format("hh:mm A");
      let key = isAddingWeight;
      if (isLevel3) {
        if (formData?.type === "800g") {
          key = "entry800g";
        } else if (formData?.type === "protein") {
          key = "protein";
        } else {
          key = "otherFood";
        }
      }

      // Get tomorrow's date
      const tomorrow = dayjs().add(1, "day").startOf("day");

      // Check if the input date is tomorrow
      const isTomorrow = dayjs(activeDay).isSame(tomorrow, "day");
      if (editData?._id) {
        await updateIngredients({
          diaryId,
          levelId,
          ingredientId: editData?._id,
          currentDayDate: activeDay,
          completionNotNeeded: isTomorrow,
          [key]: {
            name: isLevel3
              ? selectedOptionData?.name ||
                selectedOptionData?.food_name ||
                selectedCustomFood?.name
              : formData?.[key] === "others"
              ? formData.customFoodType
                ? formData.customFoodType
                : "others"
              : formData?.[key],
            noOfQty: formData?.noOfQty,
            quantity: formData?.quantity,
            time: currentTime,
            unit: isAddingWeight?.toLowerCase()?.includes("protein")
              ? "grams"
              : isLevel3 && formData?.noOfQty
              ? "grams"
              : formData?.unit,
            ...(isLevel3 &&
              (selectedOptionData?.id || selectedCustomFood?._id) && {
                extraDetails: selectedCustomFood?._id
                  ? {
                      ...selectedCustomFood,
                      isCustomFood: true,
                      serving: selectedCustomFood?.details?.serving
                    }
                  : selectedOptionData,
                ...(formData?.noOfQty && { noOfQty: formData?.noOfQty })
              })
          }
        });
      } else {
        await addIngredients({
          levelId,
          currentDayDate: activeDay,
          completionNotNeeded: isTomorrow,
          [key]: {
            name: isLevel3
              ? selectedOptionData?.name ||
                selectedOptionData?.food_name ||
                selectedCustomFood?.name
              : formData.customFoodType && formData?.[key] === "others"
              ? formData.customFoodType
              : formData?.[key],
            quantity: formData?.quantity,
            ...(formData?.noOfQty && { noOfQty: formData?.noOfQty }),
            time: currentTime,
            unit:
              isAddingWeight?.toLowerCase()?.includes("protein") && !isLevel3
                ? "grams"
                : isLevel3 && formData?.noOfQty
                ? "grams"
                : formData?.unit,
            ...(isLevel3 &&
              (selectedOptionData?.id ||
                selectedOptionData?._id ||
                selectedCustomFood?._id) && {
                extraDetails: selectedCustomFood?._id
                  ? {
                      ...selectedCustomFood,
                      isCustomFood: true,
                      serving: selectedCustomFood?.details?.serving
                    }
                  : selectedOptionData
              })
          }
        });
      }
      setSnackbarMessage("Entry logged successfully.");
      setOpenSnackbar(true);
      setFormData({ quantity: "", [isAddingWeight]: "", customFoodType: "" });
      setIsAddingWeight("");
      setIsRefreshNeeded(true);
      dispatch(getCurrentUserDiaries({ levelId, activeDay }));
      dispatch(getCurrentUserDiaryLevels(dayjs().format("YYYY-MM-DD")));

      if (!userData?.isSubscriptionActive) {
        // dispatch(getCurrentUserDiaryLevels(dayjs().format("YYYY-MM-DD")));
        dispatch(fetchCurrentUser(dayjs().format("YYYY-MM-DD")));
      }
      localStorage.setItem(
        "lastDiaryVisitedLevel",
        JSON.stringify({
          level: selectedLevel?.levelName,
          activeDay,
          unit: isLevel3 && formData?.noOfQty ? "grams" : formData?.unit,
          lastUpdated: dayjs().format("YYYY-MM-DD")
        })
      );
    } catch (error) {
      console.error(error, error?.error);
      setSnackbarMessage(error?.error || "Failed to log entry.");
      setOpenSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  React.useEffect(() => {
    window.scrollTo(0, 0);
    const scrollableElement = document.getElementById("dashboard-main"); // or document.body
    scrollableElement.scrollTo(0, 0);
  }, []);
  return (
    <Box
      color={styles.color}
      backgroundColor={styles.background}
      display="flex"
      width="100%"
      overflow="auto"
      flexDirection="column"
    >
      <Box display="flex" alignItems="center" gap={3} p="20px 0 0 10px">
        <IconButton
          onClick={() => {
            setIsAddingWeight(false);
            setOneOffItem(null);
          }}
        >
          <ChevronLeft
            sx={{ height: "35px", width: "35px", fill: styles.color }}
          />
        </IconButton>
        <Typography textTransform="capitalize" fontSize="24px">
          {isAddingWeight?.toLowerCase()?.includes("800g")
            ? "#800gChallenge"
            : isAddingWeight?.toLowerCase()?.includes("other")
            ? "Other food"
            : isAddingWeight}{" "}
          Log
        </Typography>
      </Box>
      <Box
        flexGrow={1}
        py={{ xs: 0.5, md: 3 }}
        px={{ xs: 2, md: 10 }}
        sx={{
          width: { xs: "100%", md: "100%", lg: "65%" },
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Box component="form" onSubmit={handleSubmit}>
          {isLevel3 ? (
            oneOffItem ? (
              // One-off custom food form (same as type === "customFood" from AddMealForLevel3)
              <Box sx={{ width: "100%" }}>
                <StyledTextFieldContainer>
                  <StyledInputLabel styles={styles} htmlFor="name">
                    Food Name
                  </StyledInputLabel>
                  <StyledTextField
                    styles={styles}
                    fullWidth
                    variant="outlined"
                    name="name"
                    placeholder="Enter food name"
                    value={customFoodFormData.name}
                    onChange={handleCustomFoodInputChange}
                    required
                    margin="normal"
                  />
                </StyledTextFieldContainer>

                {/* <StyledTextFieldContainer
                  sx={{
                    display: { xs: "block", md: "flex" },
                    gap: "20px",
                    marginTop: "30px",
                    marginBottom: "20px",
                    alignItems: "center"
                  }}
                >
                  <StyledInputLabel styles={styles} htmlFor="quantity">
                    Amount
                  </StyledInputLabel>
                  <StyledTextField
                    styles={styles}
                    type="number"
                    name="quantity"
                    onWheel={(e) => e.target.blur()}
                    margin="normal"
                    slotProps={{
                      htmlInput: {
                        maxLength: 13,
                        step: "1"
                      }
                    }}
                    placeholder="Enter amount"
                    value={customFoodFormData.quantity}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (Number(value) >= 0 && +value <= 9999) {
                        handleCustomFoodInputChange(e);
                        setCustomFoodFormData((prev) => ({
                          ...prev,
                          noOfQty: ""
                        }));
                      }
                    }}
                    sx={{
                      width: { xs: "36%", md: "60%" },
                      mr: { xs: 1, md: 0 },
                      mb: 0
                    }}
                  />
                  <FormControl
                    sx={{
                      width: { xs: "60%", md: "40%" },
                      marginTop: "15px",
                      svg: { fill: styles.color },
                      ".MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: styles.modLabel },
                        "&:hover fieldset": { borderColor: styles.modLabel },
                        "&.Mui-focused fieldset": {
                          borderColor: styles.disabledColor
                        }
                      }
                    }}
                  >
                    <Select
                      labelId="unit-label"
                      name="unit"
                      value={customFoodFormData.unit}
                      MenuProps={{
                        MenuListProps: {
                          sx: {
                            padding: 0,
                            ".Mui-selected": {
                              color: `${styles.background} !important`,
                              background: `${styles.color} !important`
                            }
                          }
                        }
                      }}
                      sx={{
                        color: styles.color,
                        marginTop: 0,
                        paddingTop: 0
                      }}
                      onChange={handleCustomFoodInputChange}
                    >
                      <MenuItem value="grams">Grams</MenuItem>
                      <MenuItem value="ounces">Ounces</MenuItem>
                      <MenuItem value="cups">Cups / Fists</MenuItem>
                      <MenuItem value="palms">Palms</MenuItem>
                      <MenuItem value="pounds">Pounds</MenuItem>
                    </Select>
                  </FormControl>
                  <Typography
                    display="flex"
                    fontWeight="bold"
                    justifyContent="center"
                    mt={1}
                  >
                    OR
                  </Typography>
                  <Button
                    variant={
                      customFoodFormData?.noOfQty ? "contained" : "outlined"
                    }
                    onClick={() => {
                      setCustomFoodFormData((prevData) => ({
                        ...prevData,
                        noOfQty: !customFoodFormData?.noOfQty ? "1" : "",
                        quantity: ""
                      }));
                    }}
                    sx={{
                      width: { xs: "97%", md: "30%" },
                      p: { xs: 1, md: 2 },
                      mt: 1.5,
                      borderRadius: 1,
                      textTransform: "none",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: customFoodFormData?.noOfQty
                          ? "scale(1.02)"
                          : "scale(1.05)"
                      },
                      ":disabled": {
                        backgroundColor: "#A7C8E9",
                        color: "#64AEDD",
                        pointerEvents: "none"
                      }
                    }}
                    color="primary"
                    disabled={customFoodFormData?.quantity}
                  >
                    1 Unit
                  </Button>
                </StyledTextFieldContainer> */}

                <StyledTextFieldContainer
                  style={{ display: "flex", gap: "20px", marginTop: "35px" }}
                >
                  <StyledInputLabel styles={styles} htmlFor="type">
                    Pillar Label
                  </StyledInputLabel>
                  <FormControl
                    sx={{
                      width: "100%",
                      marginTop: "15px",
                      "& .MuiRadio-root.Mui-disabled": {
                        color: styles.disabledColor
                      },
                      "& .MuiFormControlLabel-label": {
                        color: `${styles.disabledColor} !important`
                      }
                    }}
                    disabled
                  >
                    <RadioGroup
                      row
                      name="type"
                      value={customFoodFormData.type}
                      onChange={handleCustomFoodInputChange}
                      sx={{ gap: 1 }}
                    >
                      <FormControlLabel
                        value="800g"
                        control={<Radio sx={{ color: styles.disabledColor }} />}
                        label="800g"
                        sx={{ color: styles.disabledColor }}
                      />
                      <FormControlLabel
                        value="protein"
                        control={<Radio sx={{ color: styles.disabledColor }} />}
                        label="Protein"
                        sx={{ color: styles.disabledColor }}
                      />
                      <FormControlLabel
                        value="other"
                        control={<Radio sx={{ color: styles.disabledColor }} />}
                        label="Other"
                        sx={{ color: styles.disabledColor }}
                      />
                    </RadioGroup>
                  </FormControl>
                </StyledTextFieldContainer>

                {/* Three Pillars Method */}
                <StyledTextFieldContainer
                  style={{ display: "flex", gap: "20px", marginTop: "20px" }}
                >
                  <StyledInputLabel styles={styles} htmlFor="nutrient">
                    Nutrition Data
                  </StyledInputLabel>
                  <Box
                    width="100%"
                    mt={2}
                    borderRadius={2}
                    display="flex"
                    gap={isMobile ? "8px" : "28px"}
                  >
                    <Box
                      width={"33%"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      flexDirection={"column"}
                      display="flex"
                      gap={1}
                      sx={{
                        background:
                          currentTheme === "light"
                            ? "#FEECE6"
                            : styles.modBackgroundBlocks,
                        padding: isMobile ? "14px 22px" : "14px 50px"
                      }}
                      borderRadius="8px"
                    >
                      <Typography
                        fontSize="14px"
                        color={styles.inputLabelColor}
                      >
                        800g
                      </Typography>
                      <StyledTextField
                        styles={styles}
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        name="details.serving.metric_serving_amount"
                        slotProps={{ htmlInput: { maxLength: 13, step: "1" } }}
                        margin="normal"
                        value={
                          customFoodFormData?.details?.serving
                            ?.metric_serving_amount
                        }
                        onChange={handleCustomFoodInputChange}
                        sx={{
                          input: {
                            color: "#F6541C",
                            WebkitTextFillColor: "#F6541C !important",
                            textAlign: "center !important",
                            borderColor: `${styles.color} !important`
                          },
                          m: 0,
                          width: "100px",
                          padding: 1.2,
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: styles.color
                            },
                            "&:hover fieldset": {
                              borderColor: styles.color
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: styles.color
                            }
                          }
                        }}
                      />
                    </Box>

                    <Box
                      width={"33%"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      flexDirection={"column"}
                      display="flex"
                      gap={1}
                      sx={{
                        background:
                          currentTheme === "light"
                            ? "#D4E9FC"
                            : styles.modBackgroundBlocks,
                        padding: isMobile ? "14px 22px" : "14px 50px"
                      }}
                      borderRadius="8px"
                    >
                      <Typography
                        fontSize="14px"
                        color={styles.inputLabelColor}
                      >
                        Protein
                      </Typography>
                      <StyledTextField
                        styles={styles}
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        name="details.serving.protein"
                        slotProps={{ htmlInput: { maxLength: 13, step: "1" } }}
                        margin="normal"
                        value={customFoodFormData.details.serving.protein}
                        onChange={handleCustomFoodInputChange}
                        sx={{
                          input: {
                            color: "#2C75C5",
                            WebkitTextFillColor: "#2C75C5 !important",
                            textAlign: "center !important"
                          },
                          m: 0,
                          width: "100px",
                          padding: 1.2,
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: styles.color
                            },
                            "&:hover fieldset": {
                              borderColor: styles.color
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: styles.color
                            }
                          }
                        }}
                      />
                    </Box>

                    <Box
                      width={"33%"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      flexDirection={"column"}
                      display="flex"
                      gap={1}
                      sx={{
                        background:
                          currentTheme === "light"
                            ? "#fff5e6"
                            : styles.modBackgroundBlocks,
                        padding: isMobile ? "14px 22px" : "14px 50px"
                      }}
                      borderRadius="8px"
                    >
                      <Typography
                        fontSize="14px"
                        color={styles.inputLabelColor}
                      >
                        Calories
                      </Typography>
                      <StyledTextField
                        styles={styles}
                        type="number"
                        name="details.serving.calories"
                        slotProps={{ htmlInput: { maxLength: 13, step: "1" } }}
                        onWheel={(e) => e.target.blur()}
                        margin="normal"
                        value={customFoodFormData.details.serving.calories}
                        onChange={handleCustomFoodInputChange}
                        sx={{
                          input: {
                            color: "#FF9431",
                            WebkitTextFillColor: "#FF9431 !important",
                            textAlign: "center !important"
                          },
                          m: 0,
                          width: "100px",
                          padding: 1.2,
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: styles.color
                            },
                            "&:hover fieldset": {
                              borderColor: styles.color
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: styles.color
                            }
                          }
                        }}
                      />
                    </Box>
                  </Box>
                </StyledTextFieldContainer>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={
                    (!customFoodFormData.quantity &&
                      !customFoodFormData.noOfQty) ||
                    !customFoodFormData.type ||
                    !hasCustomFoodFormChanged()
                  }
                  sx={{
                    fontWeight: 600,
                    textTransform: "none",
                    backgroundColor: "#368AD0",
                    width: "100%",
                    ":disabled": {
                      backgroundColor: "#A7C8E9",
                      color: "#64AEDD"
                    }
                  }}
                >
                  {isSubmitting ? (
                    <CircularProgress color="inherit" size={24} />
                  ) : (
                    "Update"
                  )}
                </Button>
                {/* Additional Stats */}
                <StyledTextFieldContainer
                  style={{ display: "flex", gap: "20px", marginTop: "40px" }}
                >
                  <StyledInputLabel styles={styles} htmlFor="nutrient">
                    Additional Stats
                  </StyledInputLabel>
                  <Box width="100%" pt={2} borderRadius={1}>
                    {/* Carbs Group */}
                    <Box mb={2}>
                      {["carbohydrate", "fiber"].map((nutrient) => (
                        <Box
                          key={nutrient}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          py={0.5}
                        >
                          <Typography
                            fontSize="13px"
                            textTransform="capitalize"
                          >
                            {nutrient === "carbohydrate"
                              ? "Carbohydrate"
                              : "Fiber"}
                          </Typography>
                          <Box display="flex" gap="38px" alignItems="center">
                            <StyledTextField
                              styles={styles}
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              name={`details.serving.${nutrient}`}
                              slotProps={{
                                htmlInput: { maxLength: 13, step: "1" }
                              }}
                              margin="normal"
                              value={
                                customFoodFormData.details.serving[nutrient]
                              }
                              onChange={handleCustomFoodInputChange}
                              sx={{
                                input: {
                                  textAlign: "center !important",
                                  padding: "2px"
                                },
                                m: 0,
                                width: "80px"
                              }}
                            />
                            <Typography>g</Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>

                    {/* Fats Group */}
                    <Box mb={2}>
                      {["fat", "saturated_fat"].map((nutrient) => (
                        <Box
                          key={nutrient}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          py={0.5}
                        >
                          <Typography fontSize="13px">
                            {nutrient === "saturated_fat"
                              ? "Saturated Fat"
                              : "Fat"}
                          </Typography>
                          <Box display="flex" gap="38px" alignItems="center">
                            <StyledTextField
                              styles={styles}
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              name={`details.serving.${nutrient}`}
                              slotProps={{
                                htmlInput: { maxLength: 13, step: "1" }
                              }}
                              margin="normal"
                              value={
                                customFoodFormData.details.serving[nutrient]
                              }
                              onChange={handleCustomFoodInputChange}
                              sx={{
                                input: {
                                  textAlign: "center !important",
                                  padding: "2px"
                                },
                                m: 0,
                                width: "80px"
                              }}
                            />
                            <Typography>g</Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>

                    {/* Vitamins and Minerals Group */}
                    <Box>
                      {[
                        { key: "calcium", label: "Calcium", unit: "mg" },
                        { key: "iron", label: "Iron", unit: "mg" },
                        { key: "potassium", label: "Potassium", unit: "mg" },
                        { key: "sodium", label: "Sodium", unit: "mg" },
                        { key: "vitamin_a", label: "Vitamin A", unit: "mcg" },
                        { key: "vitamin_c", label: "Vitamin C", unit: "mg" },
                        { key: "vitamin_d", label: "Vitamin D", unit: "mcg" }
                      ].map(({ key, label, unit }) => (
                        <Box
                          key={key}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          py={0.5}
                        >
                          <Typography fontSize="13px">{label}</Typography>
                          <Box display="flex" gap="25px" alignItems="center">
                            <StyledTextField
                              styles={styles}
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              name={`details.serving.${key}`}
                              slotProps={{
                                htmlInput: { maxLength: 13, step: "1" }
                              }}
                              margin="normal"
                              value={customFoodFormData.details.serving[key]}
                              onChange={handleCustomFoodInputChange}
                              sx={{
                                input: {
                                  textAlign: "center !important",
                                  padding: "2px"
                                },
                                m: 0,
                                width: "80px"
                              }}
                            />
                            <Typography>{unit}</Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </StyledTextFieldContainer>
              </Box>
            ) : (
              <Box
                sx={
                  {
                    // width: { xs: "100%", md: "70%" }
                  }
                }
                // component={"form"}
              >
                {/* <StyledInputLabel
                  styles={styles}
                  htmlFor="quantity"
                  sx={{
                    fontSize: "15px",
                    mb: 2
                  }}
                >
                  Enter Food
                </StyledInputLabel> */}
                {editData ? (
                  <Box
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    gap={2}
                    borderRadius="8px"
                    padding={"12px"}
                    mb={2}
                    width={"100%"}
                    sx={{ background: styles.lightGreyColor }}
                  >
                    <Typography>{editData?.name}</Typography>
                  </Box>
                ) : (
                  <Box width={"100%"} mb={2}>
                    <FoodSearch
                      setIsMealOrRecipeTab={setIsMealOrRecipeTab}
                      setSelectedOptionData={setSelectedOptionData}
                      isBarcodeNeeded={false}
                      selectedOptionData={selectedOptionData}
                      favoriteFood={favoriteFood}
                      handleResetAmount={handleResetAmount}
                      handleSetAmount={handleSetAmount}
                      setFavoriteFood={setFavoriteFood}
                      selectedCustomFood={selectedCustomFood}
                      setSelectedCustomFood={setSelectedCustomFood}
                      type={formData.type}
                      currentDiaryAddingTab={currentDiaryAddingTab}
                      setCurrentDiaryAddingTab={setCurrentDiaryAddingTab}
                      activeDay={activeDay}
                      levelId={levelId}
                      setFormData={setFormData}
                      isAddingWeight={isAddingWeight}
                      setIsAddingWeight={setIsAddingWeight}
                      setIsRefreshNeeded={setIsRefreshNeeded}
                      setEditCustomFoodToDiary={setEditCustomFoodToDiary}
                      setEditMealToDiary={setEditMealToDiary}
                      setEditRecipeToDiary={setEditRecipeToDiary}
                    />
                  </Box>
                )}
                {/* {favoriteOptionsData?.length && !editData ? (
                <Box>
                  <Typography mb={1} fontSize={"15px"}>
                    Favorite Foods
                  </Typography>
                  <Grid container spacing={2}>
                    {favoriteOptionsData?.map((item) => (
                      <Grid item xs={12} sm={6}>
                        <Button
                          sx={{
                            background: `${
                              favoriteFood === item?.name
                                ? styles.primaryColor
                                : styles.lightGreyColor
                            } !important`,
                            color:
                              favoriteFood === item?.name
                                ? styles.background
                                : styles.color,
                            display: "flex",
                            gap: "10px",
                            justifyContent: "center",
                            padding: "10px",
                            textTransform: "none",
                            cursor: "pointer",
                            transition: "all 0.2s ease-in-out",
                            "&:hover": {
                              elevation: 3,
                              borderColor: "#358ad0"
                            }
                          }}
                          variant="outline"
                          fullWidth
                          onClick={() => {
                            handleResetAmount();
                            if (favoriteFood === item?.name) {
                              setFavoriteFood(null);
                              setSelectedOptionData(null);
                            } else {
                              if (
                                allCustomFoodOptions
                                  ?.map((data) => data.name?.trim())
                                  .includes(item?.name?.trim())
                              ) {
                                setSelectedCustomFood(
                                  allCustomFoodOptions?.find(
                                    (data) =>
                                      data.name?.trim() === item?.name?.trim()
                                  )
                                );
                                setSelectedOptionData(
                                  item?.extraDetails?.details ||
                                    item?.extraDetails
                                );
                                setFavoriteFood(null);
                              } else {
                                setFavoriteFood(item?.name);
                                setSelectedOptionData(item?.extraDetails);
                                setSelectedCustomFood(null);
                              }

                              // Scroll to and focus the amount input field
                              if (amountRef.current) {
                                amountRef.current.scrollIntoView({
                                  behavior: "smooth",
                                  block: "center"
                                });
                                amountRef.current.focus();
                              }
                            }
                          }}
                        >
                          <Typography fontSize="13px" textAlign="center">
                            {item?.name}
                          </Typography>
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              ) : (
                <></>
              )} */}
                {!selectedOptionData ? (
                  <></>
                ) : selectedOptionData?.isRecipe ? (
                  <StyledTextFieldContainer
                    sx={{
                      display: { xs: "block", md: "flex" },
                      gap: "20px",
                      marginTop: "40px",
                      marginBottom: "20px",
                      alignItems: "center"
                    }}
                  >
                    <StyledInputLabel
                      styles={styles}
                      sx={{ fontSize: "15px" }}
                      htmlFor="quantity"
                    >
                      {selectedOptionData.recipeType === "service"
                        ? "Number of Servings"
                        : "Amount Consumed"}
                    </StyledInputLabel>
                    {selectedOptionData.recipeType === "service" ? (
                      <StyledTextField
                        styles={styles}
                        ref={amountRef}
                        type="number"
                        name="noOfQty"
                        onWheel={(e) => e.target.blur()}
                        margin="normal"
                        slotProps={{
                          htmlInput: {
                            maxLength: 13,
                            step: "0.1"
                          }
                        }}
                        placeholder="Number of servings"
                        value={formData.noOfQty}
                        onChange={handleNoOfQtyChange}
                        sx={{
                          width: { xs: "70%", md: "60%" },
                          mr: { xs: 1, md: 0 },
                          mb: 0
                        }}
                      />
                    ) : (
                      <>
                        <StyledTextField
                          styles={styles}
                          ref={amountRef}
                          type="number"
                          name="quantity"
                          onWheel={(e) => e.target.blur()}
                          margin="normal"
                          slotProps={{
                            htmlInput: {
                              maxLength: 13,
                              step: "1"
                            }
                          }}
                          placeholder="Amount"
                          value={formData.quantity}
                          onChange={handleQuantityChange}
                          sx={{
                            width: { xs: "36%", md: "60%" },
                            mr: { xs: 1, md: 0 },
                            mb: 0
                          }}
                        />
                        <FormControl
                          sx={{
                            width: { xs: "60%", md: "40%" },
                            marginTop: "15px",
                            svg: {
                              fill: styles.color
                            },
                            ".MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: styles.lightGreyColor
                              },
                              "&:hover fieldset": {
                                borderColor: styles.lightGreyColor
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: styles.disabledColor
                              }
                            },
                            // 👇 Target disabled select text
                            ".MuiSelect-select.Mui-disabled": {
                              color: `${styles.disabledColor} !important`,
                              border: `1px solid ${styles.disabledColor} !important`,
                              WebkitTextFillColor: `${styles.disabledColor} !important`
                            }
                          }}
                        >
                          <Select
                            labelId="unit-label"
                            name="unit"
                            value={formData.unit}
                            disabled
                            sx={{
                              color: styles.color,
                              marginTop: 0,
                              paddingTop: 0
                            }}
                            onChange={handleInputChange}
                          >
                            <MenuItem value="grams">Grams</MenuItem>
                            <MenuItem value="ounces">Ounces</MenuItem>
                            <MenuItem value="pounds">Pounds</MenuItem>
                          </Select>
                        </FormControl>
                      </>
                    )}
                  </StyledTextFieldContainer>
                ) : selectedOptionData &&
                  selectedOptionData?.serving?.serving_url ? (
                  <StyledTextFieldContainer
                    style={{
                      display: "flex",
                      gap: "20px",
                      marginTop: "40px",
                      marginBottom: "20px",
                      alignItems: "center"
                    }}
                  >
                    <StyledInputLabel styles={styles} htmlFor="noOfQty">
                      No. of Quantity
                    </StyledInputLabel>
                    <StyledTextField
                      styles={styles}
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      ref={amountRef}
                      // min={0}
                      name="noOfQty"
                      // InputProps={{ inputProps: { min: 36, max: 40, step: "any" } }}
                      slotProps={{
                        htmlInput: {
                          maxLength: 13,
                          step: "1"
                        }
                      }}
                      margin="normal"
                      // htmlInput={{ min: 0 }}
                      placeholder="Quantity"
                      value={formData.noOfQty}
                      onChange={handleNoOfQtyChange}
                      // disabled={disabledFields.noOfQty}
                      sx={{ width: { xs: "70%" }, mb: 0 }}
                    />
                    <StyledTextField
                      styles={styles}
                      disabled
                      // min={0}
                      name="description"
                      slotProps={{
                        htmlInput: {
                          maxLength: 13,
                          step: "1"
                        }
                      }}
                      margin="normal"
                      // htmlInput={{ min: 0 }}
                      // placeholder="Enter the quantity"
                      value={selectedOptionData?.serving?.serving_description}
                      sx={{
                        width: { xs: "50%" },
                        mb: 0
                      }}
                    />
                  </StyledTextFieldContainer>
                ) : (
                  <>
                    <StyledTextFieldContainer
                      sx={{
                        display: { xs: "block", md: "flex" },
                        gap: "20px",
                        marginTop: "40px",
                        marginBottom: "20px",
                        alignItems: "center"
                      }}
                    >
                      <StyledInputLabel
                        styles={styles}
                        sx={{ fontSize: "15px" }}
                        htmlFor="quantity"
                      >
                        Amount
                      </StyledInputLabel>
                      <StyledTextField
                        styles={styles}
                        ref={amountRef}
                        type="number"
                        // min={0}
                        name="quantity"
                        onWheel={(e) => e.target.blur()}
                        margin="normal"
                        slotProps={{
                          htmlInput: {
                            maxLength: 13,
                            step: "1"
                          }
                        }}
                        placeholder=""
                        value={formData.quantity}
                        onChange={handleQuantityChange}
                        disabled={disabledFields.quantity}
                        sx={{
                          width: { xs: "36%", md: "60%" },
                          mr: { xs: 1, md: 0 },
                          mb: 0
                        }}
                      />
                      <FormControl
                        sx={{
                          width: { xs: "60%", md: "40%" },
                          marginTop: "15px",
                          svg: {
                            fill: styles.color
                          },
                          ".MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: styles.lightGreyColor
                            },
                            "&:hover fieldset": {
                              borderColor: styles.lightGreyColor
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: styles.disabledColor
                            }
                          }
                        }}
                      >
                        <Select
                          labelId="unit-label"
                          name="unit"
                          value={formData.unit}
                          MenuProps={{
                            // Force the menu to always open above
                            ...(isMobile && {
                              anchorOrigin: {
                                vertical: "top",
                                horizontal: "center"
                              },
                              transformOrigin: {
                                vertical: "bottom",
                                horizontal: "center"
                              }
                            }),
                            // Ensure menu stays above in all cases
                            getContentAnchorEl: null,
                            MenuListProps: {
                              sx: {
                                padding: 0,
                                ".Mui-selected": {
                                  color: styles.background,
                                  background: styles.color
                                }
                              }
                            },
                            PaperProps: {
                              sx: {
                                // Ensure menu is positioned correctly on mobile
                                maxHeight: {
                                  xs: "200px", // smaller height on mobile
                                  sm: "400px" // larger height on desktop
                                },
                                // Force menu above the select
                                position: "absolute !important",
                                // bottom: "100% !important",
                                mt: 1,
                                "& .MuiMenu-list": {
                                  padding: 0
                                },
                                // Add mobile-specific styling
                                "@media (max-width: 600px)": {
                                  width: "100%",
                                  marginBottom: "8px",
                                  left: "0 !important",
                                  right: "0 !important"
                                }
                              }
                            }
                          }}
                          sx={{
                            color: styles.color,
                            marginTop: 0,
                            paddingTop: 0,
                            "& .Mui-disabled": {
                              background: styles.lightGreyColor
                            },
                            // Add position context for menu
                            position: "relative"
                          }}
                          onChange={handleInputChange}
                          disabled={disabledFields.unit}
                        >
                          <MenuItem
                            sx={{
                              backgroundColor: styles.background,
                              color: styles.color,
                              paddingY: 1,
                              "&:hover": {
                                backgroundColor: styles.color,
                                color: styles.background
                              }
                            }}
                            value="grams"
                          >
                            Grams
                          </MenuItem>
                          <MenuItem
                            sx={{
                              backgroundColor: styles.background,
                              color: styles.color,
                              paddingY: 1,
                              "&:hover": {
                                backgroundColor: styles.color,
                                color: styles.background
                              }
                            }}
                            value="ounces"
                          >
                            Ounces
                          </MenuItem>
                          <MenuItem
                            sx={{
                              backgroundColor: styles.background,
                              color: styles.color,
                              paddingY: 1,
                              "&:hover": {
                                backgroundColor: styles.color,
                                color: styles.background
                              }
                            }}
                            value="cups"
                          >
                            Cups / Fists
                          </MenuItem>
                          {isAddingWeight?.toLowerCase()?.includes("800") ? (
                            <></>
                          ) : (
                            [
                              { value: "palms", label: "Palms" },
                              { value: "pounds", label: "Pounds" }
                            ]?.map(({ value, label }) => (
                              <MenuItem
                                key={value}
                                sx={{
                                  backgroundColor: styles.background,
                                  color: styles.color,
                                  paddingY: 1,
                                  "&:hover": {
                                    backgroundColor: styles.color,
                                    color: styles.background
                                  }
                                }}
                                value={value}
                              >
                                {label}
                              </MenuItem>
                            ))
                          )}
                        </Select>
                      </FormControl>
                      <Typography
                        display="flex"
                        fontWeight="bold"
                        justifyContent="center"
                        mt={1}
                      >
                        OR
                      </Typography>
                      {/* <FormControlLabel
                      control={
                        <Radio
                          checked={formData.noOfQty === "1"}
                          onChange={(e) => {
                            e.target.value = "1"; // Always set value to 1
                            handleNoOfQtyChange(e);
                          }}
                          disabled={disabledFields.noOfQty}
                        />
                      }
                      label="1 Unit"
                    /> */}
                      <StyledTextField
                        styles={styles}
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        // min={0}
                        name="noOfQty"
                        // InputProps={{ inputProps: { min: 36, max: 40, step: "any" } }}
                        slotProps={{
                          htmlInput: {
                            maxLength: 13,
                            step: "1"
                          }
                        }}
                        margin="normal"
                        // htmlInput={{ min: 0 }}
                        placeholder="Quantity"
                        value={formData.noOfQty}
                        onChange={handleNoOfQtyChange}
                        disabled={disabledFields.noOfQty}
                        sx={{ width: { xs: "100%", md: "50%" }, mb: 0 }}
                      />
                    </StyledTextFieldContainer>
                  </>
                )}

                {!selectedOptionData ? (
                  <></>
                ) : (
                  <StyledTextFieldContainer
                    style={{
                      display: "flex",
                      gap: "20px",
                      margin: "-13px 0",
                      marginTop: "-26px"
                    }}
                  >
                    <FormControl
                      sx={{
                        width: "100%",
                        marginTop: "15px",
                        svg: {
                          fill: styles.color
                        },
                        ".MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: styles.lightGreyColor
                          },
                          "&:hover fieldset": {
                            borderColor: styles.lightGreyColor
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: styles.disabledColor
                          }
                        }
                      }}
                    >
                      <RadioGroup
                        row
                        name="type"
                        value={formData.type}
                        onChange={(e) => {
                          handleInputChange(e);
                          handleResetAmount();
                          setSelectedOptionData(null);
                          setSelectedCustomFood(null);
                        }}
                        sx={{ gap: 1 }} // spacing between radios
                      >
                        <FormControlLabel
                          value="800g"
                          control={
                            <Radio
                              sx={{
                                color: styles.color,
                                "&.Mui-disabled": {
                                  color: `${styles.disabledColor} !important`,
                                  "& .MuiSvgIcon-root": {
                                    fill: `${styles.disabledColor} !important`
                                  }
                                }
                              }}
                            />
                          }
                          label="800g"
                          sx={{
                            backgroundColor: styles.background,
                            color: styles.color,
                            borderRadius: 1,
                            px: 2,
                            py: 1,
                            mr: 0,
                            "&:hover": {
                              color: styles.background
                            },
                            "& .MuiFormControlLabel-label": {
                              color: `${styles.color} !important`
                            },
                            "& .Mui-disabled": {
                              color: `${styles.disabledColor} !important`
                            }
                          }}
                          disabled
                          // disabled={!!editData?.name}
                        />

                        <FormControlLabel
                          value="protein"
                          control={
                            <Radio
                              sx={{
                                color: styles.color,
                                "&.Mui-disabled": {
                                  color: `${styles.disabledColor} !important`,
                                  "& .MuiSvgIcon-root": {
                                    fill: `${styles.disabledColor} !important`
                                  }
                                }
                              }}
                            />
                          }
                          label="Protein"
                          sx={{
                            backgroundColor: styles.background,
                            color: styles.color,
                            borderRadius: 1,
                            mr: 0,
                            px: 2,
                            py: 1,
                            "&:hover": {
                              color: styles.background
                            },
                            "& .MuiFormControlLabel-label": {
                              color: `${styles.color} !important`
                            },
                            "& .Mui-disabled": {
                              color: `${styles.disabledColor} !important`
                            }
                          }}
                          disabled
                          // disabled={!!editData?.name}
                        />

                        <FormControlLabel
                          value="other"
                          control={
                            <Radio
                              sx={{
                                color: styles.color,
                                "&.Mui-disabled": {
                                  color: `${styles.disabledColor} !important`,
                                  "& .MuiSvgIcon-root": {
                                    fill: `${styles.disabledColor} !important`
                                  }
                                }
                              }}
                            />
                          }
                          label="Other"
                          sx={{
                            backgroundColor: styles.background,
                            color: styles.color,
                            borderRadius: 1,
                            px: 2,
                            py: 1,
                            mr: 0,
                            "&:hover": {
                              color: styles.background
                            },
                            "& .MuiFormControlLabel-label": {
                              color: `${styles.color} !important`
                            },
                            "& .Mui-disabled": {
                              color: `${styles.disabledColor} !important`
                            }
                          }}
                          disabled
                          // disabled={!!editData?.name}
                        />
                      </RadioGroup>
                    </FormControl>
                  </StyledTextFieldContainer>
                )}
                {!isLevel3 ? (
                  <></>
                ) : (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={
                      isLevel3
                        ? // !(
                          //     (formData.quantity && !formData.noOfQty) ||
                          //     (!formData.quantity && formData.noOfQty)
                          //   )
                          (!formData.quantity && !formData.noOfQty) ||
                          !formData?.type ||
                          !selectedOptionData ||
                          (editData?._id && !hasFormChanged())
                        : !formData.quantity || !formData?.[isAddingWeight] ||
                          (editData?._id && !hasFormChanged())
                    }
                    sx={{
                      my: isMobile ? 2 : 4,
                      backgroundColor: "#368AD0",
                      color: "#fff",
                      width: "100%",
                      height: "42px",
                      fontWeight: "bold",
                      textTransform: "none",
                      ":disabled": {
                        backgroundColor: "#A7C8E9",
                        color: "#64AEDD"
                      }
                    }}
                  >
                    {isSubmitting ? (
                      <CircularProgress color="inherit" size={24} />
                    ) : (
                      editData?._id ? "Update" : "Add to Diary"
                    )}
                  </Button>
                )}
                {/* {formattedNutrients?.length &&
              (formData?.noOfQty || formData?.quantity) ? ( */}
                {!selectedOptionData ? (
                  <></>
                ) : (
                  <>
                    <StyledTextFieldContainer
                      style={{ display: "flex", gap: "20px", margin: "3px 0" }}
                    >
                      <Box
                        width="100%"
                        // height={64}
                        borderRadius={2}
                        display="flex"
                        gap="10px"
                      >
                        <Box
                          width={"33%"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          flexDirection={"column"}
                          display="flex"
                          gap={1}
                          sx={{
                            background:
                              currentTheme === "light"
                                ? "#FEECE6"
                                : styles.modBackgroundBlocks,
                            padding: isMobile ? "14px 30px" : "14px 50px"
                          }}
                          borderRadius="8px"
                        >
                          {/* {isMobile ? null : <AppleIcon />} */}
                          <Typography
                            fontSize="14px"
                            display="flex"
                            justifyContent="center"
                            fontWeight={400}
                            color={styles.inputLabelColor}
                          >
                            800g
                          </Typography>
                          <Typography
                            fontSize="24px"
                            fontWeight={600}
                            color="#F6541C"
                          >
                            {formData.type === "800g"
                              ? formatNumber(
                                  (
                                    (editData
                                      ? editData?.extraDetails
                                      : selectedOptionData
                                    )?.serving?.metric_serving_amount *
                                    scalingFactor
                                  ).toFixed(2) || 0
                                )
                              : 0}
                          </Typography>
                        </Box>

                        <Box
                          width={"33%"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          flexDirection={"column"}
                          display="flex"
                          gap={1}
                          sx={{
                            background:
                              currentTheme === "light"
                                ? "#D4E9FC"
                                : styles.modBackgroundBlocks,
                            padding: "14px 50px"
                          }}
                          borderRadius="8px"
                        >
                          {/* {isMobile ? null : <ProteinIcon />} */}
                          <Typography
                            fontSize="14px"
                            fontWeight={400}
                            color={styles.inputLabelColor}
                          >
                            Protein
                          </Typography>
                          <Typography
                            fontSize="24px"
                            fontWeight={600}
                            color="#2C75C5"
                          >
                            {(
                              editData
                                ? editData?.extraDetails
                                : selectedOptionData
                            )
                              ? formatNumber(
                                  (
                                    (editData
                                      ? editData?.extraDetails
                                      : selectedOptionData
                                    )?.serving?.protein * scalingFactor
                                  ).toFixed(2) || 0
                                )
                              : 0}
                          </Typography>
                        </Box>
                        <Box
                          width={"33%"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          flexDirection={"column"}
                          display="flex"
                          gap={1}
                          sx={{
                            background:
                              currentTheme === "light"
                                ? "#fff5e6"
                                : styles.modBackgroundBlocks,
                            padding: "14px 50px"
                          }}
                          borderRadius="8px"
                        >
                          {/* {isMobile ? null : <CaolriesIcon />} */}
                          <Typography
                            fontSize="14px"
                            fontWeight={400}
                            color={styles.inputLabelColor}
                          >
                            Calories
                          </Typography>
                          <Typography
                            fontSize="24px"
                            fontWeight={600}
                            color="#FF9431"
                          >
                            {(
                              editData
                                ? editData?.extraDetails
                                : selectedOptionData
                            )
                              ? formatNumber(
                                  (
                                    (editData
                                      ? editData?.extraDetails
                                      : selectedOptionData
                                    )?.serving?.calories * scalingFactor
                                  ).toFixed(2) || 0
                                )
                              : 0}
                          </Typography>
                        </Box>
                      </Box>
                    </StyledTextFieldContainer>
                    {/* {formattedNutrients?.length ? ( */}
                    <StyledTextFieldContainer
                      style={{
                        display: "flex",
                        gap: "20px",
                        marginTop: "40px"
                      }}
                    >
                      <StyledInputLabel styles={styles} htmlFor="nutrient">
                        Additional Stats
                      </StyledInputLabel>
                      <Box
                        width="100%"
                        display={"flex"}
                        justifyContent={"space-between"}
                        flexDirection="column"
                        alignItems={"center"}
                        mt={2}
                        gap={1}
                        borderRadius="8px"
                        padding={"8px 12px"}
                        sx={{ background: styles.lightGreyColor }}
                      >
                        {/* {formattedNutrients?.map(({ name, value, unit }) => (
                          <Box
                            width="100%"
                            display={"flex"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                          >
                            <Typography fontSize="13px">{name}</Typography>
                            <Typography fontSize="13px">
                              {formatNumber(value || 0) + unit}
                            </Typography>
                          </Box>
                        ))} */}
                        <Box width="100%" borderRadius={1}>
                          {/* Carbs Group */}
                          <Box mb={2}>
                            <NutrientRow
                              name="Carbohydrate"
                              unit="g"
                              notNeededPercent
                            />
                            <NutrientRow
                              name="Fiber"
                              unit="g"
                              notNeededPercent
                            />
                          </Box>

                          {/* Fats Group */}
                          <Box mb={2}>
                            <NutrientRow name="Fat" unit="g" notNeededPercent />
                            <NutrientRow
                              name="Saturated Fat"
                              unit="g"
                              notNeededPercent
                            />
                          </Box>

                          {/* Vitamins and Minerals Group */}
                          <Box>
                            <NutrientRow name="Calcium" unit="mg" />
                            <NutrientRow name="Iron" unit="mg" />
                            <NutrientRow name="Potassium" unit="mg" />
                            <NutrientRow name="Sodium" unit="mg" />
                            <NutrientRow name="Vitamin A" unit="mcg" />
                            <NutrientRow name="Vitamin C" unit="mg" />
                            <NutrientRow name="Vitamin D" unit="mcg" />
                          </Box>
                        </Box>
                      </Box>
                    </StyledTextFieldContainer>
                    {/* ) : (
                  <></>
                )} */}
                  </>
                )}
              </Box>
            )
          ) : (
            <>
              {/* <Typography
                variant="body"
                fontSize="15px"
                sx={{ color: styles.inputLabelColor, mb: "10px !important" }}
                fontWeight={500}
              >
                Select one or create a custom entry
              </Typography> */}
              <Box
                display="flex"
                flexWrap="wrap"
                flexDirection={isMobile || isTablet ? "column" : "row"}
                gap={isMobile || isTablet ? 0.75 : 1}
                sx={{
                  padding: 1,
                  borderRadius: "8px",
                  backgroundColor:
                    styles.mode === "dark"
                      ? "rgba(255,255,255,0.02)"
                      : "rgba(0,0,0,0.01)"
                }}
              >
                {options.map((option) => (
                  <Box
                    key={option.id}
                    width={isMobile || isTablet ? "100%" : "calc(50% - 8px)"}
                  >
                    <CustomRadio
                      isEditingOption={isEditing}
                      setIsEditingOption={setIsEditing}
                      styles={styles}
                      value={option.value}
                      setIsDiaryRefreshNeeded={setIsDiaryRefreshNeeded}
                      label={option.label}
                      userId={option?.userId}
                      activeDay={activeDay}
                      type={option.type}
                      id={option.id}
                      levelId={levelId}
                      checked={
                        isAddingWeight?.toLowerCase()?.includes("protein")
                          ? option.value &&
                            formData?.[isAddingWeight] === option.value
                          : formData?.[isAddingWeight] === option.value
                      }
                      onChange={() => {
                        if (option.value) {
                          setFormData({
                            ...formData,
                            [isAddingWeight]: option.value
                          });
                          // Auto-focus and scroll to quantity input
                          setTimeout(() => {
                            if (
                              quantityRef.current &&
                              formData?.[isAddingWeight] !== "others"
                            ) {
                              // quantityRef.current.focus();
                              quantityRef.current.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                              });
                            }
                          }, 100);
                          const qty = document.getElementById("no-of-quantity");
                          if (qty) {
                            qty.scrollIntoView({
                              behavior: "smooth",
                              block: "center"
                            });
                          }

                          setTimeout(() => {
                            if (
                              quantityRef.current &&
                              formData?.[isAddingWeight] !== "others"
                            ) {
                              quantityRef.current.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                              });
                            }
                          }, 100);
                        }
                      }}
                    />
                  </Box>
                ))}
              </Box>
              {/* Show additional input field if "Others" is selected */}
              {formData?.[isAddingWeight] === "others" && (
                <StyledTextFieldContainer>
                  <StyledInputLabel styles={styles} htmlFor="customFoodType">
                    {isAddingWeight?.toLowerCase()?.includes("protein")
                      ? "Other"
                      : "Custom"}{" "}
                    (e.g.,{" "}
                    {isAddingWeight?.toLowerCase()?.includes("800")
                      ? "mango"
                      : "yogurt"}
                    )
                  </StyledInputLabel>
                  <StyledTextField
                    type="text"
                    styles={styles}
                    name="customFoodType"
                    // placeholder="Enter custom food"
                    value={formData.customFoodType}
                    onChange={handleInputChange}
                    sx={{ width: "100%", mt: 2 }}
                  />
                </StyledTextFieldContainer>
              )}{" "}
              <StyledTextFieldContainer
                style={{ display: "flex", gap: "20px", marginTop: "40px" }}
              >
                <StyledInputLabel
                  styles={styles}
                  htmlFor="quantity"
                  sx={{
                    fontSize: "15px"
                  }}
                >
                  {isAddingWeight.includes("protein")
                    ? "Enter protein grams consumed"
                    : "Enter quantity"}
                </StyledInputLabel>
                <StyledTextField
                  styles={styles}
                  type="number"
                  // min={0}
                  onWheel={(e) => e.target.blur()}
                  name="quantity"
                  id="no-of-quantity"
                  inputRef={quantityRef}
                  inputProps={{}}
                  margin="normal"
                  slotProps={{
                    htmlInput: {
                      maxLength: 13,
                      step: "1"
                    }
                  }}
                  disabled={
                    isAddingWeight?.toLowerCase()?.includes("protein") &&
                    isEditing
                  }
                  value={formData.quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only numeric values and ensure it's at least 0
                    if (!value) handleInputChange(e);
                    if (
                      /^(\d*\.?\d+)$/.test(value) &&
                      Number(value) >= 0 &&
                      +value <= 9999
                    ) {
                      handleInputChange(e);
                    }
                  }}
                  sx={{
                    width: {
                      ...(selectedLevel?.levelName === "level2" &&
                      isAddingWeight?.includes("protein")
                        ? { xs: "70%" }
                        : { xs: "30%" }),
                      md: "60%"
                    }
                  }}
                />
                {isLevel3 ? (
                  <></>
                ) : !isMobile &&
                  isAddingWeight?.toLowerCase()?.includes("protein") ? (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={
                      !formData.quantity ||
                      !formData?.[isAddingWeight] ||
                      (editData?._id && !hasFormChanged())
                    }
                    sx={{
                      // marginTop: 3,
                      margin: "15px 0 10px 0",
                      width: "40%",
                      backgroundColor: "#368AD0",
                      color: "#fff",
                      // height: "42px",
                      fontWeight: "bold",
                      textTransform: "none",
                      ":disabled": {
                        backgroundColor: "#A7C8E9",
                        color: "#64AEDD"
                      }
                    }}
                  >
                    {isSubmitting ? (
                      <CircularProgress color="inherit" size={24} />
                    ) : (
                      editData?._id ? "Update" : "Add"
                    )}
                  </Button>
                ) : (
                  <></>
                )}
                {/* <StyledTextField
              styles={styles}
              margin="normal"
              placeholder="Weight Grams"
              value="Grams"
              disabled
              sx={{ width: "30%", background: styles.lightGreyColor }}
            /> */}
                {isAddingWeight?.toLowerCase()?.includes("800g") ? (
                  <FormControl
                    sx={{
                      width: "40%",
                      marginTop: "15px",
                      svg: {
                        fill: styles.color
                      },
                      ".MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: styles.lightGreyColor
                        },
                        "&:hover fieldset": {
                          borderColor: styles.color
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: styles.color
                        }
                      }
                    }}
                  >
                    <Select
                      labelId="unit-label"
                      name="unit"
                      value={formData.unit}
                      MenuProps={{
                        ...(isMobile && {
                          anchorOrigin: {
                            vertical: "top",
                            horizontal: "left"
                          },
                          transformOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                          }
                        }),
                        PaperProps: {
                          sx: {
                            backgroundColor: "#1C1C1C", // Black background for the dropdown
                            color: "#FCFCFC", // White font color for the menu items
                            "& .MuiMenuItem-root": {
                              fontSize: "15px",
                              padding: "10px" // Adjust padding inside menu items
                            },
                            "& .Mui-selected": {
                              backgroundColor: "#333" // Custom color for selected item
                            },
                            "& .MuiMenuItem-root:hover": {
                              backgroundColor: "#444" // Darker hover background
                            }
                          }
                        },
                        MenuListProps: {
                          sx: {
                            padding: 0,
                            ".Mui-selected": {
                              color: `${styles.background} !important`,
                              background: `${styles.color} !important`
                            }
                          }
                        }
                      }}
                      sx={{
                        color: styles.color,
                        marginTop: 0, // Remove any margin
                        paddingTop: 0 // Remove any padding
                      }}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                    >
                      <MenuItem
                        sx={{
                          backgroundColor: styles.background,
                          color: styles.color,
                          paddingY: 1,
                          "&:hover": {
                            backgroundColor: styles.color,
                            color: styles.background
                          }
                        }}
                        value="grams"
                      >
                        Grams
                      </MenuItem>
                      <MenuItem
                        sx={{
                          backgroundColor: styles.background,
                          color: styles.color,
                          paddingY: 1,
                          "&:hover": {
                            backgroundColor: styles.color,
                            color: styles.background
                          }
                        }}
                        value="ounces"
                      >
                        Ounces
                      </MenuItem>
                      <MenuItem
                        sx={{
                          backgroundColor: styles.background,
                          color: styles.color,
                          paddingY: 1,
                          "&:hover": {
                            backgroundColor: styles.color,
                            color: styles.background
                          }
                        }}
                        value="cups"
                      >
                        Cups / Fists
                      </MenuItem>
                      {!isAddingWeight?.toLowerCase()?.includes("800g") &&
                        [
                          { value: "palms", label: "Palms" },
                          { value: "pounds", label: "Pounds" },
                          { value: "mls", label: " MLs (millimeters)" }
                        ]?.map(({ value, label }) => (
                          <MenuItem
                            sx={{
                              backgroundColor: styles.background,
                              color: styles.color,
                              paddingY: 1,
                              "&:hover": {
                                backgroundColor: styles.color,
                                color: styles.background
                              }
                            }}
                            value={value}
                          >
                            {label}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                ) : (
                  <></>
                )}
                {isLevel3 ? (
                  <></>
                ) : isMobile ? (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={
                      !formData.quantity ||
                      !formData?.[isAddingWeight] ||
                      (editData?._id && !hasFormChanged())
                    }
                    sx={{
                      // marginTop: 3,
                      margin: "15px 0 10px 0",
                      width: "20%",
                      backgroundColor: "#368AD0",
                      color: "#fff",
                      // height: "42px",
                      fontWeight: "bold",
                      textTransform: "none",
                      ":disabled": {
                        backgroundColor: "#A7C8E9",
                        color: "#64AEDD"
                      }
                    }}
                  >
                    {isSubmitting ? (
                      <CircularProgress color="inherit" size={24} />
                    ) : (
                      editData?._id ? "Update" : "Add"
                    )}
                  </Button>
                ) : (
                  <></>
                )}
              </StyledTextFieldContainer>
              {isAddingWeight?.toLowerCase()?.includes("protein") ? (
                <StyledTextFieldContainer>
                  <Typography
                    variant="h6"
                    sx={{
                      color: styles.inputLabelColor,
                      fontSize: { xs: "14px", sm: "15px" },
                      pointerEvents: "none",
                      mb: 1.5,
                      fontWeight: 600
                    }}
                  >
                    Determining Protein Grams:
                  </Typography>
                  <Typography
                    variant="body3"
                    sx={{
                      color: styles.inputLabelColor,
                      fontSize: { xs: "13px", sm: "15px" },
                      pointerEvents: "none",
                      display: "block",
                      mb: 1.5
                    }}
                  >
                    Use nutrition labels when available.
                  </Typography>
                  <Typography
                    variant="body3"
                    sx={{
                      color: styles.inputLabelColor,
                      fontSize: { xs: "13px", sm: "15px" },
                      pointerEvents: "none",
                      display: "block",
                      mb: 1.5
                    }}
                  >
                    Here&rsquo;s a cheat sheet when you don&rsquo;t have a
                    label:
                  </Typography>
                  <TableContainer
                    component={Paper}
                    sx={{
                      my: 2,
                      boxShadow: "none",
                      width: "100%",
                      backgroundColor: "transparent",
                      overflowX: "auto"
                    }}
                  >
                    <Table
                      size="small"
                      sx={{
                        width: "100%",
                        minWidth: { xs: 300, sm: "100%" },
                        "& td, & th": {
                          backgroundColor: styles.lightGreyColor,
                          border: `1px solid ${styles.inputLabelColor}`,
                          color: styles.inputLabelColor,
                          fontSize: { xs: "12px", sm: "14px" },
                          padding: { xs: "6px 4px", sm: "8px" }
                        },
                        "& td:nth-of-type(1), & th:nth-of-type(1)": {
                          width: { xs: "48%", sm: "auto" }
                        },
                        "& td:nth-of-type(2), & th:nth-of-type(2)": {
                          width: { xs: "28%", sm: "auto" }
                        },
                        "& td:nth-of-type(3), & th:nth-of-type(3)": {
                          width: { xs: "24%", sm: "auto" }
                        }
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>Item</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>Serving Size</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>Protein (g)</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {[
                          {
                            item:
                              "Cooked Beef / Chicken / Turkey / Pork / Seafood",
                            serving: "1 oz (28 g)",
                            protein: "7"
                          },
                          {
                            item:
                              "Raw Beef / Chicken / Turkey / Pork / Seafood",
                            serving: "1 oz (28 g)",
                            protein: "5"
                          },
                          {
                            item: "Deli Meat",
                            serving: "1 oz (28 g)",
                            protein: "5"
                          },
                          {
                            item: "Cheese",
                            serving: "1 oz (28 g)",
                            protein: "7"
                          },
                          { item: "Milk", serving: "1 cup", protein: "8" },
                          { item: "Soy milk", serving: "1 cup", protein: "8" },
                          {
                            item: "Soy “meat” (TVP)",
                            serving: "1 oz (28 g)",
                            protein: "13"
                          },
                          {
                            item: "Tofu (firm)",
                            serving: "1 oz (28 g)",
                            protein: "5"
                          }
                        ].map((row) => (
                          <TableRow key={row.item}>
                            <TableCell>{row.item}</TableCell>
                            <TableCell align="center">{row.serving}</TableCell>
                            <TableCell align="center">{row.protein}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Typography
                    variant="h6"
                    sx={{
                      color: styles.inputLabelColor,
                      fontSize: { xs: "14px", sm: "15px" },
                      pointerEvents: "none",
                      mt: 3,
                      mb: 1.5
                    }}
                  >
                    When eating out:
                  </Typography>
                  <List sx={{ listStyle: "inside", py: 0 }}>
                    <ListItem sx={{ display: "list-item", py: 0.75, pl: 0 }}>
                      <Typography
                        variant="body3"
                        sx={{
                          color: styles.inputLabelColor,
                          fontSize: { xs: "13px", sm: "15px" },
                          pointerEvents: "none"
                        }}
                      >
                        Cooked protein servings are typically about the size
                        of your palm or a deck of cards. This is roughly 3.5
                        oz (100 g) and provides ~25 g of protein for meat or
                        seafood, or ~18 g of protein for tofu.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: "list-item", py: 0.75, pl: 0 }}>
                      <Typography
                        variant="body3"
                        sx={{
                          color: styles.inputLabelColor,
                          fontSize: { xs: "13px", sm: "15px" },
                          pointerEvents: "none"
                        }}
                      >
                        If the serving size is much larger or smaller,
                        estimate using the rule above.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: "list-item", py: 0.75, pl: 0 }}>
                      <Typography
                        variant="body3"
                        sx={{
                          color: styles.inputLabelColor,
                          fontSize: { xs: "13px", sm: "15px" },
                          pointerEvents: "none"
                        }}
                      >
                        Weights listed on menus are raw weights. Use the
                        table above, and reduce the listed weight by 25% if
                        it includes a bone.
                      </Typography>
                    </ListItem>
                  </List>
                </StyledTextFieldContainer>
              ) : (
                <></>
              )}
            </>
          )}

          {isLevel3 ? (
            <></>
          ) : !isMobile &&
            !isAddingWeight?.toLowerCase()?.includes("protein") ? (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={
                !formData.quantity ||
                !formData?.[isAddingWeight] ||
                (editData?._id && !hasFormChanged())
              }
              sx={{
                // marginTop: 3,
                // margin: "15px 0 10px 0",
                width: "100%",
                backgroundColor: "#368AD0",
                color: "#fff",
                // height: "42px",
                fontWeight: "bold",
                textTransform: "none",
                ":disabled": {
                  backgroundColor: "#A7C8E9",
                  color: "#64AEDD"
                }
              }}
            >
              {isSubmitting ? (
                <CircularProgress color="inherit" size={24} />
              ) : (
                editData?._id ? "Update" : "Add"
              )}
            </Button>
          ) : (
            <></>
          )}
        </Box>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={5000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity={snackbarMessage.includes("success") ? "success" : "error"}
            variant="filled"
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};

export default AddWeightForm;
